import moment from 'moment';

import { IStore } from '../../..';
import api, { request } from '../../../../api';
import { IAdminEvent } from '../store';

export const create = async (state: IStore, clubId: number, event: Partial<IAdminEvent>) => {
  const body = {
    ...event,
    end: moment(event.end)
      .endOf('day')
      .format('YYYY-MM-DDTHH:mm:ssZ'),
    start: moment(event.start)
      .startOf('day')
      .format('YYYY-MM-DDTHH:mm:ssZ')
  };

  const response = await request.post(api.admin.events(clubId), body);

  if (response.error) {
    const err =
      (response.error.statusText && response.error.statusText.join('. ')) || response.error.status;
    return { errors: { events: { msg: 'Error creating the event: ' + err } } };
  }

  return {
    adminEvents: {
      all: {
        ...state.adminEvents.all,
        [response.id]: response
      },
      current: response,
      [response.id]: response
    }
  };
};
